var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pict',{staticClass:"format-banner-blinks-image__image",attrs:{"block-name":"format-banner-blinks-image","default":_vm.imageProps.default,"sources":_vm.imageProps.sources,"alt":_vm.$t('alt')}})}
var staticRenderFns = []

export { render, staticRenderFns }